module.exports = function(data) {
var __t, __p = '';
__p += '<div id="sidebar-wrapper"></div>\n<div class="app-content">\n    <nav id="topbar-wrapper" class="navbar navbar-default"></nav>\n    <div id="page-content-wrapper">\n        ' +
((__t = ( data.loader )) == null ? '' : __t) +
'\n    </div>\n</div>\n';
return __p
}